<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">
      {{ 'LOGIN_PAGE_HEADER' | translate }}
    </ion-title>

    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="closeLogin()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true" class="homepage-content">
  <div class="page-content">
    <!-- <div class="row">
      <div class="col-md-11">
        <h1 class="title">{{'login_page.header' | translate}}</h1>
      </div>
      <div class="col-md-1">
        <span><ion-button fill="clear" (click)="closeLogin()"><ion-icon slot="icon-only" name="close"></ion-icon></ion-button></span>
      </div>
    </div> -->
    <!-- <form [formGroup]="form" (submit)="checkLogin()">
      <div class="select-group">
        <label class="label-form-control">{{'login_page.email' | translate}}</label>
        <label class="sub-label-form-control">{{'login_page.email_format' | translate}}</label>
        <ion-input class="bordered-input" required="true"
        formControlName="email"
        [class.invalid]="form.get('email')?.invalid && (form.get('email')?.dirty || form.get('email')?.touched)">
          <ion-icon slot="start" name="mail-outline" aria-hidden="true" ></ion-icon>
          <ion-button fill="clear" slot="end" aria-label="Show/hide">
             <ion-icon slot="end" name="info" aria-hidden="true"></ion-icon> 
            <ion-icon class="invalid" *ngIf="form.get('email')?.invalid && (form.get('email')?.dirty || form.get('email')?.touched)" slot="icon-only" name="information-circle-outline" aria-hidden="true"></ion-icon>
          </ion-button>
        </ion-input>
        <div class="custom-error" *ngIf="form.get('email')?.invalid && (form.get('email')?.dirty || form.get('email')?.touched)">
          <span>{{'login_page.email_format_error' | translate}}</span>
        </div>
      </div>

      <div class="select-group">
        <label class="label-form-control">{{'login_page.password' | translate}}</label>
        <ion-input class="bordered-input" [type]="showPassword ? 'text' : 'password'" formControlName="password">
          <ion-icon slot="start" name="lock-closed" aria-hidden="true" ></ion-icon>
          <ion-button fill="clear" slot="end" aria-label="Show/hide" (click)="togglePassword()">
            @if (showPassword) {
              <ion-icon slot="icon-only" name="eye-off" aria-hidden="true" style="color: gray"></ion-icon>
            } @else {
              <ion-icon slot="icon-only" name="eye" aria-hidden="true" style="color: gray"></ion-icon>
            }
          </ion-button>
        </ion-input>
      </div>
      <div class="select-group">
        <a (click)="resetPassword()" class="text-link underline-text">{{'login_page.btn_forgot_password' | translate}}</a>
      </div>
      <div class="select-group">
        <ion-button class="primary" type="submit">
          {{'login_page.btn_login' | translate}}
        </ion-button>
      </div>
    </form> -->
    <div id="okta-signin-container" [style.display]="oktaWidgetVisible ? 'block' : 'none'"></div>
    <!-- <hr>
    <div class="select-group">
        <span class="text-link ">{{'login_page.no_account_msg' | translate}}</span>
    </div>
    <div class="select-group">
      <ion-button class="bordered-primary-btn" (click)="createAccount()">
        {{'login_page.btn_create_account' | translate}}
      </ion-button>
    </div> -->
  </div>
</ion-content>
